import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "base-accordion" }
const _hoisted_2 = {
  key: 0,
  class: "icon"
}
const _hoisted_3 = { class: "title" }

import { ref, watchEffect } from "vue";
import { svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-accordion',
  props: {
    open: { type: Boolean },
    paddingBlock: { default: "1rem" },
    paddingInline: { default: "1.25rem" },
    headerPaddingBlock: { default: "0.75rem" },
    headerPaddingInline: { default: "1rem" }
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v4f1be14a": (_ctx.headerPaddingBlock),
  "v41dcb18b": (_ctx.headerPaddingInline)
}))

const props = __props;

const emit = __emit;

const opened = ref(false);

function update() {
  opened.value = !opened.value;
  emit("open", opened.value);
}

watchEffect(() => {
  opened.value = props.open;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (update()))
    }, [
      _createElementVNode("div", null, [
        (_ctx.$slots.icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "icon")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "title")
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(svgIcon), {
          icon: opened.value ? 'arrow-up' : 'arrow-down',
          size: "15px"
        }, null, 8, ["icon"])
      ])
    ]),
    (opened.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "content",
          style: _normalizeStyle({
        paddingBlock: __props.paddingBlock,
        paddingInline: __props.paddingInline,
      })
        }, [
          _renderSlot(_ctx.$slots, "content")
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})